module.exports = __webpack_public_path__ + "static/ok_emoji-9b588a91d618956fac75e39e9ffb5f01.svg";